export enum ProductPromotionType {
    NONE = 'none',
    FRIENDS = 'friends',
    CUSTOMER_CLUB = 'customer_club',
}

export const ProductPromotionTypeTrackingLabel = {
    [ProductPromotionType.NONE]: 'none',
    [ProductPromotionType.FRIENDS]: 'Friends Deal',
    [ProductPromotionType.CUSTOMER_CLUB]: 'Member Club',
};
